
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 5 3"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"5","height":"3"}}),_c('rect',{attrs:{"width":"5","height":"2","y":"1","fill":"#D00"}}),_c('rect',{attrs:{"width":"5","height":"1","y":"2","fill":"#FFCE00"}})])
          )
        }
      }
    